import React from 'react';
import { Avatar, Spin } from 'antd';
import { MessageOutlined, UserOutlined } from '@ant-design/icons';
import css from './Chat.module.css';
import dayjs from 'dayjs';

function ChatConversationList({ conversations, loading, onSelect, activeId }) {

    const formatTime = (dateStr) => {
        if (!dateStr) return '';
        const d = dayjs(dateStr);
        const now = dayjs();
        if (d.isSame(now, 'day')) return d.format('HH:mm');
        if (d.isSame(now.subtract(1, 'day'), 'day')) return 'Kecha';
        return d.format('DD.MM');
    };

    if (loading) {
        return (
            <div className={css.loadingCenter}>
                <Spin />
            </div>
        );
    }

    if (!conversations.length) {
        return (
            <div className={css.emptyConv}>
                <MessageOutlined />
                <p>Hozircha suhbatlar yo'q</p>
                <span style={{ fontSize: 12 }}>Xizmat sahifasidan yozing</span>
            </div>
        );
    }

    return (
        <div className={css.convList}>
            {conversations.map((conv, index) => (
                <div
                    key={`conv-${conv.id}-${index}`}
                    className={`${css.convItem} ${activeId === conv.id ? css.convItemActive : ''}`}
                    onClick={() => onSelect(conv)}
                >
                    <div className={css.convAvatar}>
                        <Avatar
                            size={44}
                            icon={<UserOutlined />}
                            src={conv.other_user_avatar}
                            style={{ backgroundColor: '#1890ff' }}
                        />
                        {conv.is_online && <div className={css.onlineDot} />}
                    </div>
                    <div className={css.convInfo}>
                        <p className={css.convName}>
                            { conv.other_user_name || 'Foydalanuvchi'} <br /> <span style={{ fontSize: 12, color: '#666' }}>{conv.provider_name}</span>
                        </p>
                        <p className={css.convLastMsg}>
                            {conv.last_message || 'Yangi suhbat'}
                        </p>
                    </div>
                    <div className={css.convMeta}>
                        <span className={css.convTime}>
                            {formatTime(conv.last_message_at || conv.updated_at)}
                        </span>
                        {conv.unread_count > 0 && (
                            <span className={css.convUnread}>{conv.unread_count}</span>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default ChatConversationList;
